package pl.michal_cyran.brand_hub.subpages.dayMathAd.composables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.IconBoxStyle
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun QuestionFormCard(
    title: String,
    icon: @Composable () -> Unit,
    subtitle: String,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier
            .padding(16.px),
        verticalArrangement = Arrangement.spacedBy(1.cssRem)
    ) {
        Box(IconBoxStyle.toModifier()) { icon() }

        P(
            Modifier
                .fontWeight(700)
                .color(ColorMode.current.toSitePalette().textMuted)
                .toAttrs()
        ) {
            Text(
                title
            )
        }

        P(
            Modifier
                .fontSize(0.875.cssRem)
                .lineHeight(1.25.cssRem)
                .toAttrs()
        ) {
            Text(
                subtitle
            )
        }
    }
}

